/** @format */
import Base64 from 'crypto-js/enc-base64';
import hmacSHA512 from 'crypto-js/hmac-sha512';

const APP_ID = '64c053730656499e578826c0';
const ISSUER_ID = '64c051b60656499e578826bf';
const PUBLIC_KEY =
	'eTz.live_faf2ab8387b08df3d51d85c5e43f11e9d46f4a49cd9943b0f2fcd174bb7830d1';
const X_API_KEY =
	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcmVhdGVkIjoxNjU0NzYwNjE0MjUwLCJlbnYiOiJkZXZlbG9wbWVudCIsImlkIjoiNjJhMWE0YTY4MDRmN2EwMDEzNzVkZGMxIiwidmVyc2lvbiI6MCwiaWF0IjoxNjU0NzYwNjE0LCJleHAiOjE2NTQ3Njc2MTR9.xo5LLqxhakDwknrBPc-guLyeE97UBaLupjSXn4rNfM4';

const getAuthSignatureHeader = ({ body }) => {
	const boatPayloadStr = JSON.stringify(body);
	const boatHashStr = `${boatPayloadStr}etz${APP_ID}etz${PUBLIC_KEY}etz${ISSUER_ID}`;

	const hmac = hmacSHA512(boatHashStr, PUBLIC_KEY);
	const xAuthHeader = Base64.stringify(hmac);

	return {
		'X-AUTH-SIGNATURE': xAuthHeader,
	};
};

export const authMethod = async (body) => {
	const authxx = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-ISSUER-ID': ISSUER_ID,
		'X-APP-ID': APP_ID,
		'X-API-KEY': X_API_KEY,
		'X-AUTH-SIGNATURE': getAuthSignatureHeader({ body })['X-AUTH-SIGNATURE'],
	};
	return authxx;
};
